import { useState } from 'react';
import dayjs from 'dayjs';

export function useDatePickerField(fieldValue?: string) {
  const dateValue = fieldValue ? dayjs(fieldValue) : undefined;
  const [open, setOpen] = useState(false);
  const [tempDate, setTempDate] = useState<Date | undefined>(
    dateValue?.toDate(),
  );
  const [displayMonth, setDisplayMonth] = useState<Date>(
    dateValue?.toDate() ?? new Date(),
  );

  const handleOpenChange = (openState: boolean) => {
    if (openState) {
      const current = fieldValue ? dayjs(fieldValue).toDate() : new Date();
      setTempDate(current);
      setDisplayMonth(current);
    }
    setOpen(openState);
  };

  const handleDateSelect = (date: Date | undefined) => {
    if (date) setTempDate(date);
  };

  const handleConfirm = (
    onChange: (iso: string) => void,
    onBlur: () => void,
  ) => {
    if (tempDate) {
      onChange(dayjs(tempDate).toISOString());
      onBlur();
      setOpen(false);
    }
  };

  const handlePreviousMonth = () =>
    setDisplayMonth((prev) => dayjs(prev).subtract(1, 'month').toDate());

  const handleNextMonth = () =>
    setDisplayMonth((prev) => dayjs(prev).add(1, 'month').toDate());

  const handleYearMonthSelect = (year: number, month: number) =>
    setDisplayMonth(
      dayjs()
        .year(year)
        .month(month - 1)
        .date(1)
        .toDate(),
    );

  const handleTodaySelect = () => {
    const today = new Date();
    setTempDate(today);
    setDisplayMonth(today);
  };

  return {
    open,
    setOpen,
    tempDate,
    setTempDate,
    displayMonth,
    setDisplayMonth,
    handleOpenChange,
    handleDateSelect,
    handleConfirm,
    handlePreviousMonth,
    handleNextMonth,
    handleYearMonthSelect,
    handleTodaySelect,
  };
}
